import React from 'react';
import { useTranslation } from 'react-i18next';
import { Heart, Sparkles } from 'lucide-react';
import { Button } from './ui/button';

const FirstStepSection = () => {
  const { t } = useTranslation();
  
  return (
    <section className="relative py-16 overflow-hidden">
      {/* Warm Background with Image */}
      <div className="absolute inset-0 z-0">
        <img 
          src="/Images/wave.avif"
          alt="Mountain landscape"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-rich-chocolate/85 via-warm-sage/75 to-charcoal/90"></div>
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center space-y-6">
          {/* Compact Header */}
          <div className="space-y-4">
            <div className="flex justify-center space-x-2">
              <Heart className="h-6 w-6 text-cream-white animate-pulse" />
              <Heart className="h-5 w-5 text-soft-taupe animate-pulse" style={{animationDelay: '0.3s'}} />
              <Heart className="h-6 w-6 text-cream-white animate-pulse" style={{animationDelay: '0.6s'}} />
            </div>
            
            <h2 className="text-3xl md:text-4xl font-serif font-light text-cream-white leading-tight">
              {t('firststep.title1')} {t('firststep.title2')}
            </h2>
            
            <p className="text-2xl md:text-3xl font-serif font-light text-soft-taupe italic">
              {t('firststep.subtitle')}
            </p>
          </div>

          {/* Compact Content */}
          <div className="space-y-6 max-w-4xl mx-auto">
            <div className="bg-cream-white/10 backdrop-blur-sm p-6 rounded-2xl border border-cream-white/20">
              <p className="text-base md:text-lg font-light text-cream-white leading-relaxed">
                {t('firststep.text1')}
              </p>
            </div>

            <p className="text-lg md:text-xl font-light text-cream-white/90">
              {t('firststep.text2')}
            </p>

            <blockquote className="text-lg md:text-xl font-serif font-light text-cream-white italic border-l-4 border-soft-taupe pl-6">
              {t('firststep.quote')}
            </blockquote>
          </div>

          {/* Compact CTA */}
          <div className="pt-8">
            <Button 
              size="lg"
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              className="group relative bg-gradient-to-r from-soft-taupe via-warm-sage to-soft-taupe hover:from-warm-sage hover:to-soft-taupe text-cream-white font-medium px-10 py-4 rounded-xl transition-all duration-500 shadow-2xl hover:shadow-3xl hover:scale-105"
            >
              <span className="relative z-10 flex items-center">
                <Heart className="mr-2 h-5 w-5 group-hover:animate-pulse" />
                {t('firststep.cta')}
                <Sparkles className="ml-2 h-5 w-5 group-hover:rotate-180 transition-transform duration-700" />
              </span>
            </Button>
            
            <p className="text-sm text-cream-white/80 font-light italic mt-4">
              {t('firststep.note')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FirstStepSection;